import { copyToClipboard } from "@/utils"
import { Check, Copy } from "lucide-react"
import { useState } from "preact/hooks"
import { ComponentChildren } from "preact"

interface CopyableCellProps {
  value: string
  className?: string
  title?: string
  children?: ComponentChildren
}

export function CopyableCell({ value, className, title = "Copy Value", children }: CopyableCellProps) {
  const [showCopyConfirmed, setShowCopyConfirmed] = useState(false)

  function handleCopy(e: MouseEvent) {
    e.preventDefault()
    e.stopImmediatePropagation()
    copyToClipboard(value)
    setShowCopyConfirmed(true)
    setTimeout(() => {
      setShowCopyConfirmed(false)
    }, 2000)
  }

  return (
    <div className={`flex items-center ${className || ""}`}>
      {children ?? <span>{value}</span>}
      {showCopyConfirmed ? (
        <Check className="ml-2 h-4 w-4 text-green-500" />
      ) : (
        <Copy
          className="ml-2 h-4 w-4 cursor-pointer hover:text-blue-500"
          title={title}
          onClick={handleCopy}
        />
      )}
    </div>
  )
}

